import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { LoadingService } from '@services/loading/loading.service';
import { detect } from 'detect-browser';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [TitleCasePipe],
})
export class LoginComponent implements OnInit {
  public env = environment.forntend_url;
  public submitted: boolean = false;
  public loginForm: FormGroup;
  public browserInfo: Record<any, any> = detect();
  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    public authService: AuthService,
    public toastr: ToastrService,
    public loader: LoadingService,
    public titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  get formData() {
    return this.loginForm.controls;
  }

  login() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    let deviceId: string = '';
    deviceId = localStorage.getItem('deviceId');

    if (!deviceId || deviceId === 'null') {
      deviceId = uuidv4();
      localStorage.setItem('deviceId', deviceId);
    }

    const credential = {
      email: this.formData.email.value,
      password: this.formData.password.value,
      device_type: this.browserInfo ? this.browserInfo.type : 'not-supported',
      device_id: deviceId,
      notification_token: '1234123412341234',
      site_type: 'admin',
    };

    this.successLogin(credential);
  }

  successLogin(data: object) {
    this.authService.Login(data).subscribe(
      (res) => {
        if (res['success'] === true) {
          if (res['data']['role_name'] === 'Media Admin') {
            this.router.navigate(['/dashboard/inventory/retail']);
          } else {
            this.router.navigate(['/dashboard']);
          }

          this.toastr.success(res['message']);
        } else {
          return this.toastr.warning(
            'Please contact to admin',
            this.titleCasePipe.transform(res['message'])
          );
        }
      },
      (error) => {
        console.log(error);
        if (error?.error?.errors) {
          return this.toastr.error(error.error.errors);
        } else {
          return this.toastr.error('Please Enter Right Credential');
        }
      }
    );
  }
}
